import type { QUnitType } from 'dayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import type { DashboardFilter } from '../../useDashboardStore';
import { convertDateRangeValues } from '../../widgets/filterHelpers';

dayjs.extend(utc);

// Local day first: `convertDateRangeValues` returns local-anchored instants, so
// `dayjs.utc(date)` would land a day early on every positive offset (CUS-318).
const asUtcCalendarDay = (date: Date) =>
  dayjs.utc(dayjs(date).format('YYYY-MM-DD'));

export const toIsoBounds = (
  dateRange: DashboardFilter['dateRange'],
  precision: QUnitType = 'day'
): { from?: string; to?: string } => {
  if (!dateRange) {
    return {};
  }

  const { startDate, endDate } = convertDateRangeValues(dateRange);
  if (!startDate || !endDate) {
    return {};
  }

  return {
    from: asUtcCalendarDay(startDate).startOf(precision).toISOString(),
    to: asUtcCalendarDay(endDate).endOf(precision).toISOString(),
  };
};
